module.exports = __webpack_public_path__ + "static/HKGrotesk-LightItalic-04fe47df3ace15019bb39f4a138ea316.woff";